import { Image } from '@mui/icons-material';
import { Box, Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { colors } from '../../assets/utils/colors';
import CustomeFileForm from '../../components/forms/CustomeFileForm';
import CustomeMultlineForm from '../../components/forms/CustomeMultlineForm';
import CustomTextField from '../../components/forms/CustomTextField';
import * as Yup from 'yup';

// ################### validation schema ###############
const createPromotionSchema = Yup.object({
    promotion_name: Yup.string().required('Promotion name is required'),
    description: Yup.string().required('Promotion description is required'),
    file: Yup.mixed().required('Promotion image is required'),
});

const CreatePromotion = () => {
    // -> handle file preview
    const [filePreview, setFilePreview] = useState('');
    return (
        <>
            <Formik
                enableReinitialize
                initialValues={{
                    promotion_name: '',
                    file: '',
                    description: '',
                }}
                validationSchema={createPromotionSchema}
            >
                {(formik) => (
                    <Form>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item sm={7} sx={{ mt: 2 }}>
                                <Box
                                    sx={{
                                        height: 225,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 5,
                                        background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor1})`,
                                    }}
                                >
                                    {filePreview ? (
                                        <>
                                            <img
                                                src={filePreview}
                                                alt="img"
                                                style={{
                                                    width: '100%',
                                                    height: '10em',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Image
                                                sx={{
                                                    width: '100%',
                                                    height: '7em',
                                                    objectFit: 'contain',
                                                    opacity: 0.7,
                                                }}
                                            />
                                        </>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item sm={5}>
                                <CustomeFileForm
                                    name="file"
                                    label={'Promotion image'}
                                    type="file"
                                    color="primary"
                                    setFilePreview={setFilePreview}
                                    formik={formik}
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="promotion_name"
                                    label={'Promotion name'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomeMultlineForm
                                    name="description"
                                    label={'Promotion description'}
                                    color="primary"
                                    rows={5}
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="app-btn"
                                        onClick={formik.handleSubmit}
                                    >
                                        Create promotion
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default CreatePromotion;
